import axios from 'axios';

export const  URL_BASE=process.env.NODE_ENV === 'production' ? "/api/" : "https://certificadosdegasperu.com/api/";
//const URL_BASE_WEB = process.env.NODE_ENV != 'production' ? "https://rsu.udh.edu.pe/" : "/";

export default()=> {
  return axios.create({
    baseURL:URL_BASE
  })
}
